<template>
  <div>
    <div class="stream-video"></div>
  </div>
</template>

<script>
import router from "@/router";
import CamerasSdk from "@omnicloud/cameras-sdk-v2";
import { EventBus } from "@/libs/event-bus";

import { ref, onMounted, nextTick, onUnmounted } from "@vue/composition-api";

export default {
  setup() {
    const valid = ref(true);
    let cameraSDK = null;
    const error_message = ref("");

    const appLoading = document.getElementById("loading-bg");
    if (appLoading) {
      appLoading.style.display = "block";
    }

    onMounted(() => {
      const stream_video = document.querySelector(".stream-video");
      EventBus.on(`setLang`, onSetLang);

      if (router.currentRoute.query.data) {
        const encodedData = router.currentRoute.query.data;
        const decodedData = atob(encodedData);
        const config = JSON.parse(decodedData);

        config.container = ".stream-video";

        nextTick(() => {
          cameraSDK = new CamerasSdk({
            ...config,
            pusher_app_key: window.__env?.VUE_APP_LARAVEL_PUSHER_APP_KEY,
            pusher_host: window.__env?.VUE_APP_LARAVEL_PUSHER_HOST,
            pusher_port: window.__env?.VUE_APP_LARAVEL_PUSHER_PORT,
            pusher_app_cluster: window.__env.VUE_APP_LARAVEL_PUSHER_APP_CLUSTER || "mt1",
          });
        });
      }
    });

    function onSetLang(lang) {
      this.camerasSdk?.setLang(lang);
    }

    onUnmounted(() => {
      EventBus.off(`setLang`, this.onSetLang);
    });

    return {
      valid,
      error_message,
    };
  },
};
</script>

<style lang="scss">
.stream-video {
  width: 100vw;
  height: 100vh;
}

.error-message {
  font-size: 5vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
